export default __webpack_public_path__ + "static/media/studyMaterialImg.cfe1e117.svg";